export default {
  develop: false,
  country: "rs",
  export: false,  // testing => true; (default) | production => FALSE;
  show_potrebno: true,
};
